import { lazy, Suspense, useEffect, useState } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { Toaster } from 'sonner'
import { getPortalToken, onPortalTokenChange, resumePortalSession } from './portal-api'
import { PortalForgotPage, PortalLoginPage, PortalSetPasswordPage, PortalSignupPage } from './PortalAuthPages'
import { PortalHomePage } from './PortalHomePage'
import { JoinPage } from './JoinPage'

const SuperAdminPage = lazy(() => import('../pages/super/SuperAdminPage'))
const SuperTenantDataPage = lazy(() => import('../pages/super/SuperTenantDataPage'))
const TenantUsersPage = lazy(() => import('../pages/super/TenantUsersPage'))

function RequirePortalSession({ children }: { children: JSX.Element }): JSX.Element {
  const [token, setToken] = useState(getPortalToken())
  const [resuming, setResuming] = useState(!getPortalToken())
  useEffect(() => onPortalTokenChange(() => setToken(getPortalToken())), [])
  useEffect(() => {
    if (getPortalToken()) return
    void resumePortalSession().finally(() => setResuming(false))
  }, [])
  if (!token && resuming) return <></>
  return token ? children : <Navigate to="/login" replace />
}

/**
 * Pusula Portal (bulut, `VITE_APP_ROLE=portal`): müşteri portalı, davet yedek sayfası ve Super Admin.
 * ERP arayüzü yalnızca masaüstü Veri Merkezinde sunulur.
 */
export function PortalApp(): JSX.Element {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path="/login" element={<PortalLoginPage />} />
        <Route path="/signup" element={<PortalSignupPage />} />
        <Route path="/forgot" element={<PortalForgotPage />} />
        <Route path="/set-password" element={<PortalSetPasswordPage />} />
        <Route path="/join" element={<JoinPage />} />
        <Route path="/portal" element={<RequirePortalSession><PortalHomePage /></RequirePortalSession>} />
        {/* Super Admin — X-Admin-Key ile */}
        <Route path="/super-admin" element={<SuperAdminPage />} />
        <Route path="/super-admin/tenant-users" element={<TenantUsersPage />} />
        <Route path="/super-admin/tenant/:tenantId/data" element={<SuperTenantDataPage />} />
        <Route path="*" element={<Navigate to="/portal" replace />} />
      </Routes>
      <Toaster position="top-right" richColors closeButton />
    </Suspense>
  )
}
